module.exports = __webpack_public_path__ + "media/images/team/julian-koch-81cf13cba2cd3dfe817ac50eb7b2e17b.png";